<template>
  <div class="cards">
    <Card
      v-for="(card, index) in cards"
      :key="`${index}-${card.suit}-${card.rank}`"
      :card="card"
      :is-current="index === 0"
      :isBack="isBack"
      :canInteract="canInteract"
      @cardAccepted="$emit('cardAccepted')"
      @cardRejected="$emit('cardRejected')"
      @cardSkipped="$emit('cardSkipped')"
      @hideCard="$emit('hideCard')"
    />
    <!-- <Card
      v-for="(card, index) in cards"
      :key="card"
      :card="card"
      :is-current="index === 0"
      @cardAccepted="$emit('cardAccepted')"
      @cardRejected="$emit('cardRejected')"
      @cardSkipped="$emit('cardSkipped')"
      @hideCard="$emit('hideCard')"
    /> -->
  </div>
</template>

<script>
import Card from "@/components/Card";
export default {
  name: "CardDeck",
  components: { Card },
  props: {
    cards: {
      type: Array,
      required: true
    },
    isBack: {
      type: Boolean,
      required: true
    },
    canInteract: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.cards {
  position: relative;
  display: flex;
  // margin: 50px;
  width: 270px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
